import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)``;

export const ContactLink = styled('span')`
  cursor: pointer;
  font-weight: 700;
  text-decoration: underline;
`;
